export default __webpack_public_path__ + "static/media/websites.71f4da62.svg";